import { differenceInMinutes } from "date-fns"

interface TimeWindowDeletionRestrictionParams {
  limit: number
  createdAt: Date
  isCustomerServiceCenter: boolean
}

export const isTimeWindowDeletionRestricted = ({
  limit,
  createdAt,
  isCustomerServiceCenter,
}: TimeWindowDeletionRestrictionParams): boolean => {
  if (isCustomerServiceCenter) return false

  return differenceInMinutes(new Date(), createdAt) > limit
}
